import React from "react";
import { useNavigate } from "react-router-dom";
import { AppGeneralContextProvider } from "../../../shared/GeneralContext/GeneralContext";
import "./Footer.css";
import innovationLogo from "../../../img/icons/InnovationMatch_Logo-2048x256.webp";
import Instagram from "../../atoms/iconsComponent/Instagram";
import Linkedin from "../../atoms/iconsComponent/Linkedin";
import RocketDreams from "../../atoms/iconsComponent/RocketDreams";
import { instagram, linkedin, rocket ,terms , privacy , contact, home} from "api/const/socialLink";
import { MediaMobile, MediaTablet } from "api/const/MediaQuery";
import useMediaQuery from "hook/useMediaQuery";
import clsx from "clsx";

const Footer = () => {
const tablet = useMediaQuery(MediaTablet)
const mobile = useMediaQuery(MediaMobile)
  return (
    <>
      <div className="row d-flex flex-wrap justify-content-start footer">
        <div className="d-flex col-12 flex-column">
          <div className={clsx("d-flex w-100  footer-inner  ",
          {"flex-row justify-content-between align-items-center":!tablet},
          {"flex-column justify-content-center align-items-center":tablet})}>
            <div className={clsx("d-flex justify-content-start  align-items-center  ",
            {"col-4 justify-content-start  ":!tablet},
            {"col-12 justify-content-center ":tablet})}>
              <a href={home}>
                <img src={innovationLogo} style={{ height: "30px" }} alt="" />
              </a>
            </div>
            {tablet ? <hr  className="footer-line w-100"/> : null  }
            <div className={clsx(" d-flex justify-content-end align-items-center  ",
            {"col-7 h-100 justify-content-end tae":!tablet},
            {"col-12 justify-content-center tac":tablet})}>
              <p className="m-0 p-0">
                INNOVATION MATCH POWERED BY ROCKET DREAMS SRL | VIA PASTRENGO
                14, 20159 MILAN (ITALY){" "}
              </p>
            </div>
          </div>
          <hr  className="footer-line w-100"/>
          <div className={clsx("w-100 h-100 d-flex   footer-bottom__right ",
           {"flex-row justify-content-end":!tablet},
           {"flex-column align-items-center  justify-content-center":tablet})}>
            <a href={terms}>{` TERMS AND CONDITION ${tablet ? "" : "|"}`}</a>
            <a href={privacy}> {`PRIVACY POLICY ${tablet ? "" : "|"}`}</a>
            <a href={contact}> CONTACT US </a>
          </div>
          {tablet ? <hr  className="footer-line w-100"/> : null  }

          <div
            className={clsx("d-flex footer-bottom__right",
            {"flex-row ":!tablet},
            {"flex-column align-items-center  justify-content-center":tablet})}
            style={{ fontWeight: "400" }}
          >
            <div className={clsx("w-50 d-flex icons-container  ",
             {"pb-4 justify-content-center":tablet}
            )}>
              <a href={instagram}>
                <Instagram className="icon-footer" />
              </a>
              <a href={linkedin}>
                <Linkedin className="icon-footer" />
              </a>
              <a href={rocket}>
                <RocketDreams className="icon-footer" />
              </a>
            </div>
            <div className={clsx("w-50 d-flex ",
             {"w-50 justify-content-end":!tablet},
             {"w-100 justify-content-center tac":tablet})}>
              <p>
                &#169; 2023 Rocket Dreams srl IT12223150967 | REA MI 2648966
              </p>
            </div>
          </div>
        </div>
      </div>
      { tablet &&
        <div className="end-separator"/>
      }

    </>
  );
};

export default Footer;
